import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { plusIconDark } from '../icons/plus-icon-dark';
import { plusIconLight } from '../icons/plus-icon-light';

import type { TButton } from './models';

export const ButtonIncreaseComponent: FC<TButton> = ({
    configs,
    disabled,
    onClick,
    styles,
    theme,
}) => {
    const Icon = theme === 'light' ? plusIconLight : plusIconDark;

    return (
        <button
            className={cn(styles.roundButton, configs.selectors.plus)}
            data-test-id="btnPlus"
            disabled={disabled}
            onClick={onClick}
        >
            {Icon}
        </button>
    );
};
